import React, {useCallback, useEffect, useState} from 'react';
import Card from './Card';
import BtnSwitch from "../Button/BtnSwitch";
import styles from './Card.module.css';
import stylesSwitch from '../Button/BtnSwitch.module.css';
import {useUser} from "../../contexts/UserContext";

function CardComing({ id, lien, image, titre, userRegistered, userRegisteredLabel, userNonRegisteredLabel, rows, waiting, onToggle }) {
    const { user } = useUser();
    function renderContentBasedOnRole() {
        if (!user) return null;

        if (user.roles.includes("ROLE_USER") || user.roles.includes("ROLE_REFERENT")) {
            return (
                <div className={styles.switchContainer}>
                    <BtnSwitch
                        active={userRegistered}
                        waiting={waiting}
                        waitingLabel={"En attente"}
                        activeLabel={userRegisteredLabel}
                        inactiveLabel={userNonRegisteredLabel}
                        onToggle={() => onToggle(id)}
                        id={`switch-${id}`}
                        name={`switch-${titre}`}
                        classNames={stylesSwitch.sliderCard}
                    />
                </div>
            );
        } else if (user.roles.includes("ROLE_COACH")) {
            return null;
        } else {
            return null;
        }
    }

    return (
        <Card lien={lien} image={image}>
            <h3 className={styles.cardTitle}>{titre}</h3>
            {rows.map((row, index) => (
                <span key={index}>{row}</span>
            ))}

            { renderContentBasedOnRole() }

        </Card>
    );
}

export default CardComing;
